<app-navbar-style-two></app-navbar-style-two>
<app-seo-agency></app-seo-agency>


<section class="pt-5">
    <div class=" container-fluid contact-banner mt-5">
        <h2 style="color: #ffffff;">Sign Up</h2>
        <p style="color: #ffffff;">Already signed up? &nbsp;<a href="/sign-in">Log in</a></p>
    </div>
</section>

<section class="py-5">
    <div class="container pt-5 pb-5" style="box-shadow: 0 0 15px rgba(0, 0, 0, 0.1);">
      <div class="row g-4">
        <!-- Left Column -->
        <div class="col-lg-6 d-flex justify-content-center align-items-center">
            <img src="assets/img/sign-up-image.jpg" alt="Image">
        </div>
  
        <!-- Right Column - Form -->
        <div class="col-lg-6">
          <h4 class="fw-bold mb-3">Sign-Up</h4>
          <form>
            <div class="row mb-0">
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" placeholder="First Name">
              </div>
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" placeholder="Last Name">
              </div>
            </div>
            <div class="row mb-0">
                <div class="col-md-6 mb-3">
                    <input type="email" class="form-control" placeholder="Your Email">
                </div>
              <div class="col-md-6 mb-3">
                <input type="text" class="form-control" placeholder="Your Phone">
              </div>
            </div>
            <div class="row mb-0">
                <div class="col-md-6 mb-3">
                    <input type="email" class="form-control" placeholder="Company Name">
                </div>
                <div class="col-md-6 mb-3">
                    <select class="form-select" aria-label="Select Country">
                      <option selected disabled>Select Country</option>
                      <option value="India">India</option>
                      <option value="United States">United States</option>
                      <option value="Canada">Canada</option>
                      <option value="United Kingdom">United Kingdom</option>
                      <option value="Australia">Australia</option>
                    </select>
                </div>
                  
            </div>
            <div class="row mb-0">
                <div class="col-md-6 mb-3">
                    <input type="text" class="form-control" placeholder="Password">
                </div>
                <div class="col-md-6 mb-3">
                    <input type="text" class="form-control" placeholder="Confirm Password">
                </div>
            </div>
            <button class="btn start-btn fw-bold d-flex align-items-center justify-content-center mt-3 px-4">
                <i class="bi bi-fire me-1"></i> Sign Up
              </button>              
          </form>
        </div>
      </div>
  
      <!-- Contact Details -->
      <div class="text-center mt-5">
        <p class="fw-bold">Contact us by Phone Number or Email Address</p>
        <h4 class="text-success fw-bold mb-1">+1 234 567 890</h4>
        <h5 class="text-danger fw-semibold">info@ringpilot.com</h5>
        <div class="mt-3">
          <a href="#" class="text-dark me-3"><i class="bi bi-twitter fs-5"></i></a>
          <a href="#" class="text-dark me-3"><i class="bi bi-youtube fs-5"></i></a>
          <a href="#" class="text-dark me-3"><i class="bi bi-facebook fs-5"></i></a>
          <a href="#" class="text-dark me-3"><i class="bi bi-linkedin fs-5"></i></a>
          <a href="#" class="text-dark"><i class="bi bi-instagram fs-5"></i></a>
        </div>
      </div>
    </div>
  </section>


<app-footer-style-two></app-footer-style-two>